import React, { useEffect, useState } from "react";
import { Typography } from "../../../../../components/__common/Typography/Typography";
import { Container } from "../../../../../components/Grid/Grid";
import Tabs from "../../../../../components/__common/_controls/Tab/Tab";
import LearnMoreMap from "./LearnMoreMap";
import { MapRegions } from "../../../../../data/landing-page";
import { MapRegion } from "../../../../../types/landing-page";
import PrivacyRightsModal from "../../PrivacyRightsModal/PrivacyRightsModal";
import { useTranslation } from "react-i18next";
import "./LearnMore.scss";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { UserState } from "../../../../../store/reducers/user-reducer";
import { Regions } from "../../../../../data/regions";

const LearnMore: React.FC = () => {
  const [selectedRegion, setSelectedRegion] = useState<MapRegion | undefined>(
    undefined
  );
  const [showPrivacyRightsModal, setShowPrivacyRightsModal] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  const handleToggleModal = () => {
    setShowPrivacyRightsModal(!showPrivacyRightsModal);
  };

  const getMapRegion = () => {
    let landingPageRegion = MapRegions.find(
      (region) => region.code === userCountryCode
    );

    // if specific country (e.g. US, China, Turkey)
    if (landingPageRegion) {
      setSelectedRegion(landingPageRegion);
      return;
    }

    const region = Regions.filter((region) =>
      region.countries.some((country) => country.code === userCountryCode)
    )[0];

    // if specific region
    if (region.name === "Europe" || region.name === "Latin America") {
      landingPageRegion = MapRegions.find(
        (hubRegion) => hubRegion.code === region.name
      );
      setSelectedRegion(landingPageRegion);
    } else {
      // Global
      setSelectedRegion(MapRegions[0]);
    }
  };

  useEffect(() => {
    if (userCountryCode) {
      getMapRegion();
    }
  }, [userCountryCode]);

  return (
    <>
      <div className="learn-more" id="learn-more">
        <Container>
          <Typography variant="h1" className="learn-more__title sharp-sans">
            {t("PRIVACY_HUB_LEARN_MORE_TITLE")}
          </Typography>
          <Typography
            variant="title3"
            className="learn-more__subtitle"
            weight="wMedium"
          >
            {t("PRIVACY_HUB_LEARN_MORE_DESC")}
          </Typography>
          <Tabs className="learn-more__tabs">
            {MapRegions.map((region, i) => (
              <Tabs.Tab
                key={i}
                name="regions_tab"
                title={
                  region.name === "Global"
                    ? t("PRIVACY_HUB_LEARN_MORE_OTHER_REGIONS")
                    : region.name
                }
                type="2depth"
                checked={selectedRegion?.name === region.name}
                onChange={() => setSelectedRegion(region)}
              />
            ))}
          </Tabs>
          <Container className="learn-more__map svg">
            <LearnMoreMap
              code={selectedRegion?.code}
              handleToggleModal={handleToggleModal}
            />
          </Container>
        </Container>
      </div>
      {showPrivacyRightsModal && selectedRegion && (
        <PrivacyRightsModal
          show={showPrivacyRightsModal}
          onClickClose={handleToggleModal}
          country={selectedRegion.rightsCode}
        />
      )}
    </>
  );
};

export default LearnMore;
